import { Switch, Route, Redirect, Link as RouterLink, useLocation } from 'react-router-dom';

import Makes from './views/Makes';
import Models from './views/Models';
import VolumesTrims from './views/VolumesTrims';
import Regions from './views/Regions';
import Log from './views/Log';

import Footer from './components/general/Footer';

import { useDispatch } from "react-redux";

import { useEffect } from 'react';

import { log as actionsLog } from "./store/actions";

const { getLog } = actionsLog;

function App() {

  const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLog());
    }, []);

  const location = useLocation();

  const getMenuClasses = input => {
    return input == location.pathname ? 
      'bg-gray-900 text-yellow-500 px-3 py-2 rounded-md text-sm font-medium cursor-default' : 
      'text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium';
  }

  return (
    <div className="bg-gray-800 text-gray-400">
      <main>
        <nav className="bg-gray-900">
            <div className="mx-auto px-4">
                <div className="flex items-center justify-between h-16">
                  <div className="flex-shrink-0 flex items-center">
                    <img className="h-8" src="https://d10y2oj5s0rxih.cloudfront.net/images/logo/logo@3x.png" />
                    <div className="text-white text-xl ml-4 uppercase">
                      Make Model Editor <small>v</small>4.0
                    </div>
                  </div>
                  <div className="hidden md:block">
                    <div className="ml-10 flex items-baseline space-x-4">
                      <RouterLink className={ getMenuClasses('/makes') } to="/makes">Makes</RouterLink>
                      <RouterLink className={ getMenuClasses('/models') } to="/models">Models</RouterLink>
                      <RouterLink className={ getMenuClasses('/volumes-and-trims') } to="/volumes-and-trims">Volumes & Trims</RouterLink>
                      <RouterLink className={ getMenuClasses('/regions') } to="/regions">Regions</RouterLink>
                      <RouterLink className={ getMenuClasses('/log') } to="/log">Log</RouterLink>
                    </div>
                  </div>
                </div>
            </div>
        </nav>
        <section className="p-2">
          <Switch>
            <Route exact path="/">
              <Redirect to="/makes" />
            </Route>
            <Route path="/makes" component={ Makes } />
            <Route path="/models" component={ Models } />
            <Route path="/volumes-and-trims" component={ VolumesTrims } />  
            <Route path="/regions" component={ Regions } />
            <Route path="/log" component={ Log } />
          </Switch>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default App;
